<template>
  <div></div>
</template>

<script>
import { newList } from './store/modules/advantages'
import { newClients } from './store/modules/clients'
import { newTabs } from './store/modules/forms'
import { newExplonations } from './store/modules/how'
import { newMessages } from './store/modules/main'
import { newLinks } from './store/modules/navigation'
import { newPartners } from './store/modules/partners'
import { newPositionList } from './store/modules/positions'
import { newAddress } from './store/modules/proprietary'
import langBD from '@/assets/dictionary/index'
import { mapActions } from 'vuex'

export default {
  computed: {
    currentLang() {
      return this.$store.state.main.currentLang
    },
  },
  methods: {
    ...mapActions(['INIT']),
    changeActualDic(lang) {
      this.$store.commit('changeDic', langBD[lang])
    },
    updateValues(lang) {
      const {
        sectionMain,
        forms,
        howItWorks,
        nav,
        partners,
        sectionPositions,
        sectionAdvantages: { lists, transporter, shipper },
        clientsSection: { list },
        footer: { address },
      } = langBD[lang]

      this.$store.commit('changeMainMassage', newMessages(sectionMain))
      this.$store.commit(
        'changeAdvantagesData',
        newList(lists, transporter, shipper)
      )
      this.$store.commit('changeClients', newClients(list))
      this.$store.commit('changeFormsTabs', newTabs(forms))
      this.$store.commit('changeHowExplonation', newExplonations(howItWorks))
      this.$store.commit('changeNavigationLinks', newLinks(nav))
      this.$store.commit('changePartners', newPartners(partners))
      this.$store.commit(
        'changePositionList',
        newPositionList(sectionPositions)
      )
      this.$store.commit('changeProprietaryAddress', newAddress(address))
    },
  },
  created() {
    this.changeActualDic(this.currentLang, this.newData)
    this.updateValues(this.currentLang)
    this.INIT()
  },
}
</script>
